export interface Result_RegistroQR{
    nro_respuesta:number;
    mensaje:string;
    url:string;
}

export interface Result_Reporte{
    nro_respuesta:number;
    mensaje:string;
}

export class QR_registro{
    id_qr:number | undefined;
    url_qr:string| undefined;
    url_qr_redirec:string| undefined;
    id_usuario_creacion:number | undefined;
    estado:number| undefined;
}

/**
 * Personalización (color + ícono) de un QR ya registrado (pantalla
 * "Registrados"), guardada por id_qr. Al igual que QR_Personalizado, vive
 * solo en localStorage: ver StorageService.guardarEstiloQRRegistrado.
 */
export interface QR_Estilo{
    color: string;
    logoSrc: string | undefined;
    logoSize: number;
}

/**
 * QR personalizado guardado por el usuario (color + ícono central).
 * Se persiste solo en el navegador (localStorage), no en el backend:
 * ver StorageService.guardarQRPersonalizado.
 */
export class QR_Personalizado{
    id: string | undefined;
    urlPagina: string | undefined;
    urlGenerada: string | undefined;
    color: string | undefined;
    logoSrc: string | undefined;
    logoSize: number | undefined;
    thumbnail: string | undefined;
    fechaGuardado: string | undefined;
}


export class QR_List{
    id_qr: number | undefined;
    url_qr: string ='';
    user: string | undefined;
    estado: string | undefined;
    estado_bool:number =0;
    url_qr_redirec: string  = "";
    fecha_creacion: Date | undefined;
}


//SECCION PARA REPORTE 

export class QR_Detalle_Visita{
   qr_detalle_visita_total: QR_Detalle_Visita_Total | undefined;
   qr_detalle_visita_pais: QR_Detalle_Visita_Pais[] | undefined;
   qr_detalle_dispositivo: QR_Detalle_Dispositivo[] | undefined;
}

export class QR_Detalle_Visita_Total{
    cantidad:number | undefined;
}
export class QR_Detalle_Visita_Pais{
    cantidad:number | undefined;
    country: string | undefined;
    id_qr: number | undefined;
    url:string = "";
}

export class QR_Detalle_Dispositivo{
    cantidad: number | undefined;
    tipo_dispositivo: string | undefined;
}

export class Lista_Historial_Visitas{
    name:string |  undefined;
    value: number | undefined;
    y: number  | undefined; 
}

export class Reporte_x_pais{
    id_Qr: number | undefined;
    country: string | undefined;
    city: string | undefined;
    cantidad: number | undefined;
    distrito:string | undefined;
}

export class Reporte_x_Ciudad{
    id_Qr: number | undefined;
    country: string | undefined;
    name: string | undefined;
    distrito: string | undefined;
    value: number | undefined;
    y:number | undefined;

}

export class Reporte_x_pais_Grafico{
 
    country: string | undefined;
    value: number | undefined;
}


export class Reporte_Paises{
    country: string | undefined;
    count_cantidad:number = 0;
}

export class HistorialAccion{
    id_historial: number | undefined;
    id_usuario: number | undefined;
    usuario: string | undefined;
    accion: string | undefined;
    id_qr: number | undefined;
    url_qr: string | undefined;
    fecha_accion: Date | undefined;
}